import { FormGroup, Input, Label } from "reactstrap";

const InputNumber = ({ label, name, value, onChange, placeholder = "0" }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    // Mengonversi string ke Integer secara otomatis
    // Jika input kosong, set ke 0 agar tidak menyebabkan error di backend
    const intValue = value === "" ? 0 : parseInt(value, 10);

    // Memanggil fungsi onChange asli dengan format event yang sama
    onChange({
      target: {
        name,
        value: intValue,
      },
    });
  };

  const handleKeyPress = (event) => {
    const keyCode = event.which || event.keyCode;
    const keyValue = String.fromCharCode(keyCode);
    // Hanya izinkan angka 0-9
    if (!/^[0-9]+$/.test(keyValue)) {
      event.preventDefault();
    }
  };

  return (
    <FormGroup>
      <Label className="fw-bold">{label}</Label>
      <Input
        type="number"
        name={name}
        value={value}
        onChange={handleChange}
        onKeyPress={handleKeyPress}
        placeholder={placeholder}
        min="0"
      />
    </FormGroup>
  );
};

export default InputNumber;
